import React, { useState } from 'react';

function ShowMoreContent({ text, characterLimit }) {
    const [showMore, setShowMore] = useState(false);

    const toggleShowMore = () => {
        setShowMore(!showMore);
    };

    return (
        <div>
            {showMore ? (
                <div>{text}</div>
            ) : (
                <div>{text.slice(0, characterLimit)}
                    {text.length > 500 &&
                        <>
                            <span> ...</span>
                            <a onClick={toggleShowMore}>
                                Show More
                            </a>
                        </>
                    }
                </div>
            )}
        </div>
    );
}

export default ShowMoreContent;